<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      checkValidation: checkValidation$ | async,
    };
    as data
  ) {
    @if (projektTimeSection) {
      <div id="skiss-table">
        @if (startDate && endDate) {
          <lib-interactive-table
            [id]="question.id"
            [title]="
              question.translations?.list['title']
                | translate: data.activeLang : question.title
            "
            [tableHeading]="
              question.translations?.list['title']
                | translate: data.activeLang : question.title
            "
            [rows]="ROW"
            [columns]="yearColumns"
            [sumRow]="true"
            [formControl]="beloppFormControl"
            [maxColsDesktop]="7"
            [tableContentToRight]="true"
            [inputType]="InputType.Amount"
            [expansionTitle]="t('question_budget_skiss_expansion_header')"
            [disableResize]="true"
            (saveExpanded)="updateBudgetTables()"
            size="medium"
            suffix="SEK"
            [readOnly$]="readOnly$"
            [tableValidation]="['SkissBudgetKostnaderRequired']"
            [checkValidation$]="checkValidation$"
            [defaultValue]="0"
            [hideValidation]="data.readOnly === ReadonlyState.Reader"
            [browseLarge]="browseLarge()"
            [browseMedium]="browseMedium()"
            [browseSmall]="browseSmall()"
          ></lib-interactive-table>
        } @else {
          <span class="budget-skiss-question-title">{{
            question.translations?.list['title']
              | translate: data.activeLang : question.title
          }}</span>
          <p>
            @if (!(startDate && endDate)) {
              <span>{{ t('question_budget_skiss_validation_missing') }}</span>
            }
            <br />
            @if (!(startDate && endDate)) {
              <span>{{
                t('question_budget_skiss_validation_missing_date')
              }}</span>
            }
          </p>
          @if (!(startDate && endDate) && data.checkValidation) {
            <div class="invalid-feedback"></div>
          }
        }
      </div>
    } @else {
      <p>Fråga om projekttid saknas i formuläret</p>
    }
  }
</ng-container>
